import { useTranslation } from 'react-i18next';
import { OrderForm } from '../../orders/OrderForm';
import { upsertOrder } from '../../orders/OrdersService';
import { useAlert } from 'react-alert';

export const DayShortageItem = ({ shortage }) => {

    const { t } = useTranslation('common');
    const alert = useAlert();

    const getShortagesTitle = (shortage) => {
        return shortage.shortageList.map((product, index) =>
                (index + 1) + '. ' + product.title + ' ' + product.amount + ' ' + t('unit.kg'))
            .join('\n');
    };

    const handleSubmit = (order) => {
        upsertOrder(order)
            .then(() => alert.success(t('alert:saveSuccess')))
            .catch(() => alert.error(t('alert:saveError')));
    };

    const handleCancel = () => {
        // ignore
    };

    return (
        <>
            {shortage != null && shortage.shortageList.length > 0
                ? <div>
                    <span title={getShortagesTitle(shortage)}>
                    {t('monthMenu:shortageList')} {shortage.shortageList.length}
                    </span>
                    <OrderForm onSubmit={handleSubmit}
                               onCancel={handleCancel}
                               orderId={null}
                               isOrdersPage={false}
                               shortage={shortage.shortageList} />
                </div>
                : <span>-</span>}
        </>
    );
};